import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { lastValueFrom, Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

interface HttpOptions  {
  headers: HttpHeaders
  params?: HttpParams
}

interface HttpOptionsDowload  {
  headers: HttpHeaders
  observe: 'response'
  responseType: 'json'
  params?: HttpParams
}


export class BaseRepoService {

  protected BASE_PATH_URL = '';

  constructor(protected http: HttpClient) {

  }

  protected getHttpOptions(params: HttpParams | null = null): HttpOptions {
    return  {
      headers: this.httpHeaders(),
      params: params ? params : undefined
    }
  }

  protected getHttpOptionsForExcel(params: HttpParams | null): HttpOptionsDowload {
    return {
      headers: this.httpHeaders(),
      observe: 'response',
      responseType: 'blob' as 'json',
      params: params ? params : undefined
    };
  }

  protected get<T>(url: string, options: HttpOptions): Observable<T>{
    url = this.BASE_PATH_URL + url;
    return this.http.get<T>(url, options).pipe(catchError(this.handleServerError));
  }

  protected post<T>(url: string, body: any, options: HttpOptions): Observable<T> {
    url = this.BASE_PATH_URL + url;
    return this.http.post<T>(url, body, options).pipe(catchError(this.handleServerError));
  }

  protected put<T>(url: string, body: any, options: HttpOptions): Observable<T> {
    url = this.BASE_PATH_URL + url;
    return this.http.put<T>(url, body, options).pipe(catchError(this.handleServerError));
  }

  protected handleServerError(badResponse: HttpErrorResponse): Observable<never> {
    return throwError(() => badResponse);
  }

  getUrl(url: string, mapObj: {[key:string]: string}): string {
    const re = new RegExp(Object.keys(mapObj).join("|"),"gi");
    return url.replace(re, matched => mapObj[matched]);
  }


  /* --------------------------------------------------------------- */
  /*                              HEADERS                            */
  /* --------------------------------------------------------------- */
  protected httpHeaders(): HttpHeaders {
    return this.httpHeadersDefault().set('Accept', 'application/json');
  }

  private httpHeadersDefault(): HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json');
  }
}
